import {Reservation, Status} from '@wix/ambassador-table-reservations-v1-reservation/types'

export const isReservationSuccessful = (reservation: Reservation) => {
  return reservation.status === Status.RESERVED || reservation.status === Status.REQUESTED
}
